module.exports = __webpack_public_path__ + "static/media/faqBackground.7f9c3aa0.svg";